/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICRTouchConnectionScheduleSitesConfig
 */
export interface ICRTouchConnectionScheduleSitesConfig {
    /**
     * 
     * @type {number}
     * @memberof ICRTouchConnectionScheduleSitesConfig
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ICRTouchConnectionScheduleSitesConfig
     */
    connectionId: number;
    /**
     * 
     * @type {number}
     * @memberof ICRTouchConnectionScheduleSitesConfig
     */
    scheduleId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ICRTouchConnectionScheduleSitesConfig
     */
    siteNumbers: Array<number> | null;
}

/**
 * Check if a given object implements the ICRTouchConnectionScheduleSitesConfig interface.
 */
export function instanceOfICRTouchConnectionScheduleSitesConfig(value: object): value is ICRTouchConnectionScheduleSitesConfig {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('connectionId' in value) || value['connectionId'] === undefined) return false;
    if (!('scheduleId' in value) || value['scheduleId'] === undefined) return false;
    if (!('siteNumbers' in value) || value['siteNumbers'] === undefined) return false;
    return true;
}

export function ICRTouchConnectionScheduleSitesConfigFromJSON(json: any): ICRTouchConnectionScheduleSitesConfig {
    return ICRTouchConnectionScheduleSitesConfigFromJSONTyped(json, false);
}

export function ICRTouchConnectionScheduleSitesConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICRTouchConnectionScheduleSitesConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'connectionId': json['connectionId'],
        'scheduleId': json['scheduleId'],
        'siteNumbers': json['siteNumbers'] == null ? null : json['siteNumbers'],
    };
}

  export function ICRTouchConnectionScheduleSitesConfigToJSON(json: any): ICRTouchConnectionScheduleSitesConfig {
      return ICRTouchConnectionScheduleSitesConfigToJSONTyped(json, false);
  }

  export function ICRTouchConnectionScheduleSitesConfigToJSONTyped(value?: ICRTouchConnectionScheduleSitesConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'connectionId': value['connectionId'],
        'scheduleId': value['scheduleId'],
        'siteNumbers': value['siteNumbers'],
    };
}

